import { matchPath } from 'react-router-dom';
import { createSelector } from 'reselect';
import get from 'lodash/fp/get';

import { productsCategories } from 'constants/products';
import { subscriptionCategories } from 'constants/subscriptions';

const getRouterState = get('router');
const getLocation = createSelector(getRouterState, get('location'));

export const getPathname = createSelector(getLocation, get('pathname'));
export const getSearch = createSelector(getLocation, get('search'));
export const getIsStandalone = createSelector(getSearch, search => {
  const params = new URLSearchParams(search);
  return params.has('standalone');
});
export const hasNoFreeShipping = createSelector(getSearch, search => {
  const params = new URLSearchParams(search);
  return params.has('origin') && params.get('origin') === 'yjfwm';
});
export const getHash = createSelector(getLocation, get('hash'));

/**
 * By default every /account/ page renders the sidebar
 * On specific cases like the Resubscription full-window page we want to hide it
 */
export const shouldShowAccountSidebar = createSelector(
  getPathname,
  pathname => pathname !== '/account/resubscribe'
);

export const isOnSupplementsQuestionRoute = createSelector(getPathname, pathname => {
  const match = matchPath('/:consultationType/*', pathname);

  return match?.params?.consultationType === 'supplements-consultation';
});

export const isOnSupplementsLpSearchTrafficRoute = createSelector(
  getPathname,
  pathname =>
    pathname === '/pages/supplements-search' ||
    pathname === '/pages/supplements-before-after-search'
);

export const isOnSupplementsFeedbackRoute = createSelector(
  getPathname,
  getSearch,
  (pathname, search) => {
    const match = matchPath('/:feedbackType/*', pathname);

    const params = new URLSearchParams(search);

    return (
      match?.params?.feedbackType === 'supplements-feedback' ||
      (pathname === '/feedback/confirmation' &&
        params.get('data-from') === productsCategories.SUPPLEMENTS)
    );
  }
);

export const getSubscriptionCategory = createSelector(getPathname, pathname => {
  const match = matchPath('/account/subscription/:category/*', pathname);
  const category = match?.params?.category ?? '';

  if (!subscriptionCategories.includes(category)) {
    return null;
  }

  return category;
});

export const subscriptionCategoryAndStatus = createSelector(getSearch, search => {
  const params = new URLSearchParams(search);

  return {
    category: params?.get('category'),
    status: params?.get('status'),
  };
});

export const subscriptionProductFromCart = createSelector(getSearch, search => {
  const params = new URLSearchParams(search);

  return params?.get('add');
});

export const getFeedbackOriginGate = createSelector(getSearch, search => {
  const params = new URLSearchParams(search);

  return params?.get('data-from');
});
